import React from "react";

const About: React.FC = () => {
  return (
    <div className="content-container">
      <div className="card-container">
        <h2>기업 정보</h2>
        <p>
          <strong>사명:</strong> 트래시스(주)
        </p>
        <p>
          <strong>주소:</strong> 광주광역시 북구 자미로 6번길 45, 311호
        </p>
        <p>
          <strong>TEL:</strong> 062-653-5555
        </p>
        <p>
          <strong>FAX:</strong> 061-983-0297
        </p>
        <p>
          <strong>이메일:</strong> trasys21@nate.com
        </p>
      </div>
    </div>
  );
};

export default About;
